module.exports = __webpack_public_path__ + "static/media/siddharth-vidhana-soudha-trip.6d993c05.png";